import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

/**
 * Support — one real address, and no ticket theatre.
 *
 * There is no helpdesk, no chat widget and no ticket system behind this
 * product, so this page does not draw one. A contact form that posts nowhere
 * is worse than a mailto: the founder believes she has been heard.
 *
 * When there is a support desk, this page grows a form. Until then the honest
 * version is the address of the person who actually reads it.
 */
export const Route = createFileRoute("/settings/support")({
  component: Support,
});

const SUPPORT_EMAIL = "hello@getomina.com";

function Support() {
  return (
    <div className="setwrap">
      <header className="sethead">
        <Link to="/settings" className="setback">
          <ArrowLeft size={16} aria-hidden />
          Settings
        </Link>
        <h1 className="settitle">Support</h1>
      </header>

      <section className="setnote">
        <h2>Talk to a person</h2>
        <p>
          There is no ticket queue — mail goes to someone who works on Omina and
          can change it.
        </p>
        <p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="setlink">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p>
          If something looks wrong on a screen, say which screen and what you
          expected. That is usually enough to find it.
        </p>
      </section>
    </div>
  );
}
